module.exports = __webpack_public_path__ + "img/EH.4d3df256.svg";